import Vue from 'vue'
import VueRouter from 'vue-router'

import SiteLayout from '@/views/layout/SiteLayout'



const ForgotpasswordView = () => import('@/views/site/ForgotpasswordView')
const LoginView = () => import('@/views/site/LoginView')
const ResetPasswordView = () => import('@/views/site/user/common/ResetPasswordView')

//User Views


Vue.use(VueRouter)

var routes;
let userData = JSON.parse(localStorage.getItem('userData'));
var siteRoutesArray = [ //Routes for sites
    { path: '', component: LoginView, name: 'Login', meta: { title: 'Login' } },
    { path: '/site', component: LoginView, name: 'Login', meta: { title: 'Login' } },
    { path: '/site/forgot', component: ForgotpasswordView, name: 'Forgot Password', meta: { title: 'Forgot Password' } },
    { path: '/password_reset/*', component: ResetPasswordView, name: 'Reset Password', meta: { title: 'Reset Password' } },

    




];

routes = [{
    path: '/',
    component: SiteLayout,
    children: siteRoutesArray
},]
// routes = [{
//     path: '/auth/:provider/callback',
//     component: {
//       template: '<div class="auth-component"></div>'
//     }
//   },]

const router = new VueRouter({
    mode: 'history',
    base: process.env.PUBLIC_PATH,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 };
        }
    }
})

export default router